import {
  IAcademicsClasses,
  EAcademicBoard,
  EAcademicStream,
  EAcademicSection,
  EStandardLevel,
} from '../../apis/academics/academicsClassesAndCourses.interfaces';

export const mockAcademicsClasses: IAcademicsClasses[] = [
  {
    id: 1,
    name: 'Class 1',
    description: 'Class 1',
    standardLevel: EStandardLevel.CLASS_1,
    academicYear: '2021-2022',
    classTutor: 101,
    strength: 35,
    courseIds: [1, 2, 3, 4],
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 2,
    name: 'Class 2',
    description: 'Class 2',
    standardLevel: EStandardLevel.CLASS_2,
    academicYear: '2021-2022',
    classTutor: 102,
    strength: 32,
    courseIds: [1, 2, 3, 4],
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 3,
    name: 'Class 3',
    description: 'Class 3',
    standardLevel: EStandardLevel.CLASS_3,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 4,
    name: 'Class 4',
    description: 'Class 4',
    standardLevel: EStandardLevel.CLASS_4,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 5,
    name: 'Class 5',
    description: 'Class 5',
    standardLevel: EStandardLevel.CLASS_5,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 6,
    name: 'Class 6A',
    description: 'Class 6 Section A',
    section: EAcademicSection.A,
    standardLevel: EStandardLevel.CLASS_6,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 7,
    name: 'Class 6B',
    description: 'Class 6 Section B',
    section: EAcademicSection.B,
    standardLevel: EStandardLevel.CLASS_6,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 8,
    name: 'Class 7A',
    description: 'Class 7 Section A',
    section: EAcademicSection.A,
    standardLevel: EStandardLevel.CLASS_7,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 9,
    name: 'Class 7B',
    description: 'Class 7 Section B',
    section: EAcademicSection.B,
    standardLevel: EStandardLevel.CLASS_7,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 10,
    name: 'Class 8A',
    description: 'Class 8 Section A',
    section: EAcademicSection.A,
    standardLevel: EStandardLevel.CLASS_8,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 11,
    name: 'Class 8B',
    description: 'Class 8 Section B',
    section: EAcademicSection.B,
    standardLevel: EStandardLevel.CLASS_8,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 12,
    name: 'Class 9A',
    description: 'Class 9 Section A',
    section: EAcademicSection.A,
    standardLevel: EStandardLevel.CLASS_9,
    board: EAcademicBoard.CBSE,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 13,
    name: 'Class 9B',
    description: 'Class 9 Section B',
    section: EAcademicSection.B,
    standardLevel: EStandardLevel.CLASS_9,
    board: EAcademicBoard.CBSE,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 14,
    name: 'Class 10A',
    description: 'Class 10 Section A',
    section: EAcademicSection.A,
    standardLevel: EStandardLevel.CLASS_10,
    board: EAcademicBoard.CBSE,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 15,
    name: 'Class 10B',
    description: 'Class 10 Section B',
    section: EAcademicSection.B,
    standardLevel: EStandardLevel.CLASS_10,
    board: EAcademicBoard.CBSE,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 16,
    name: 'Class 11 Science A',
    description: 'Class 11 Science Section A',
    section: EAcademicSection.A,
    standardLevel: EStandardLevel.CLASS_11,
    board: EAcademicBoard.CBSE,
    stream: EAcademicStream.SCIENCE,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 17,
    name: 'Class 11 Science B',
    description: 'Class 11 Science Section B',
    section: EAcademicSection.B,
    standardLevel: EStandardLevel.CLASS_11,
    board: EAcademicBoard.CBSE,
    stream: EAcademicStream.SCIENCE,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 18,
    name: 'Class 11 Commerce',
    description: 'Class 11 Commerce',
    standardLevel: EStandardLevel.CLASS_11,
    board: EAcademicBoard.CBSE,
    stream: EAcademicStream.COMMERCE,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 19,
    name: 'Class 11 Arts',
    description: 'Class 11 Arts',
    standardLevel: EStandardLevel.CLASS_11,
    board: EAcademicBoard.CBSE,
    stream: EAcademicStream.ARTS,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 20,
    name: 'Class 12 Science A',
    description: 'Class 12 Science Section A',
    section: EAcademicSection.A,
    standardLevel: EStandardLevel.CLASS_12,
    board: EAcademicBoard.CBSE,
    stream: EAcademicStream.SCIENCE,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 21,
    name: 'Class 12 Science B',
    description: 'Class 12 Science Section B',
    section: EAcademicSection.B,
    standardLevel: EStandardLevel.CLASS_12,
    board: EAcademicBoard.CBSE,
    stream: EAcademicStream.SCIENCE,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 22,
    name: 'Class 12 Commerce',
    description: 'Class 12 Commerce',
    standardLevel: EStandardLevel.CLASS_12,
    board: EAcademicBoard.CBSE,
    stream: EAcademicStream.COMMERCE,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 23,
    name: 'Class 12 Arts',
    description: 'Class 12 Arts',
    standardLevel: EStandardLevel.CLASS_12,
    board: EAcademicBoard.CBSE,
    stream: EAcademicStream.ARTS,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 24,
    name: 'Class 12 Vocational',
    description: 'Class 12 Vocational Studies',
    standardLevel: EStandardLevel.CLASS_12,
    board: EAcademicBoard.CBSE,
    stream: EAcademicStream.VOCATIONAL,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 25,
    name: 'Class 11 Vocational',
    description: 'Class 11 Vocational Studies',
    standardLevel: EStandardLevel.CLASS_11,
    board: EAcademicBoard.CBSE,
    stream: EAcademicStream.VOCATIONAL,
    academicYear: '2021-2022',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
];
